/**
 * Словари EO «Аудит» — русские подписи action/entity_type и акцент бейджа
 * действия (V1 index.html:15317-15351). Акцент подбирается по includes в
 * ПОРЯДКЕ списка (как V1 getColor) и мапится на css-класс в audit.module.css.
 */

export const ACTION_LABELS: Record<string, string> = {
  login: "Вход", open_tab: "Открыл вкладку", switch_role: "Сменил роль",
  view_booking: "Смотрел бронь", view_schedule: "Смотрел расписание",
  oo_tab: "OO → вкладка", eo_tab: "EO → вкладка", op_tab: "Оператор → вкладка",
  created_booking: "Создал бронь", updated_booking: "Изменил бронь", cancelled_booking: "Отменил бронь",
  created_lead: "Создал лид", updated_lead: "Изменил лид", deleted_lead: "Удалил лид",
  moved_booking: "Перенёс бронь", displaced_booking: "Отменённая/архивная уступила слот", archived_booking: "Архивировал", restored_booking: "Восстановил",
  game_report: "Отчёт об игре", accept_discrepancy: "Принял расхождение", oo_edit_prices: "Изменил цены игры",
  assigned_operator: "Назначил оператора", notified_operators: "Уведомил операторов",
  created_staff: "Принял сотрудника", updated_staff: "Обновил сотрудника", fired_staff: "Уволил",
  /* 03.10 (владелец): найм и увольнение в V4 — найм, возврат, ссылка-приглашение в бота, Telegram */
  hired_staff: "Принял сотрудника", added_former_staff: "Внёс бывшего сотрудника", rehired_staff: "Вернул сотрудника",
  staff_invite_issued: "Ссылка-приглашение", staff_tg_bound: "Telegram привязан", staff_tg_unbound: "Отвязал Telegram",
  staff_tg_moved: "Telegram перенесён", staff_tg_conflict: "Чужой Telegram по ссылке", generated_token: "Токен входа",
  staff_invite_refused: "Ссылка отклонена: выдавший уже не вправе",
  created_mc: "Создал МК", updated_mc: "Обновил МК", deleted_mc: "Удалил МК",
  mc_add: "Добавил МК-оператора", mc_remove: "Убрал МК-оператора", mc_status_set: "МК статус",
  set_special_source: "Изменил специсточник", created_lead_source: "Добавил источник", deleted_lead_source: "Удалил источник",
  hall_admin_report: "Отчёт АЗ", tea_cleanup_confirmed: "Уборка чайной",
  created_extra_work: "Доп.работа", mk_status_operator: "МК статус (опер.)", mk_status_set: "МК статус (OO)",
  updated_slots: "Обновил слоты", updated_quest_prices: "Обновил цены", updated_mc_prices: "Обновил цены МК",
  created_tea_room: "Создал чайную", updated_tea_room: "Обновил чайную", deleted_tea_room: "Удалил чайную",
  updated_booking_sources: "Обновил источники", updated_finance_config: "Обновил финансы-конфиг",
  /* PRC-4 (A38/A41): справочник доп. услуг поверх master_classes. */
  updated_service_consumables: "Нормы услуги", updated_service_resources: "Ресурсы услуги",
  updated_service_price: "Цена услуги (филиал)", migrated_mc_network: "Миграция услуг",
};

export const ENTITY_LABELS: Record<string, string> = {
  booking: "Брони", report: "Отчёты", staff: "Сотрудники", config: "Настройки",
  assignment: "Назначения", master_class: "МК", extra_work: "Доп.работы", prices: "Цены",
  tea_room: "Чайные", hall_admin: "Админ зала", slot: "Слоты", mc_booking_ops: "МК-операторы",
  session: "Сессии", view: "Просмотры",
};

export type AuditAccent =
  | "green" | "cyan" | "red" | "orange" | "purple" | "gold" | "pink" | "muted" | "default";

/* Порядок важен: первый includes-матч выигрывает (V1 ACTION_COLORS). */
const ACCENTS: [string, AuditAccent][] = [
  ["login", "purple"], ["open_tab", "muted"], ["switch", "purple"], ["view", "muted"],
  ["created", "green"], ["hired", "green"], ["updated", "cyan"], ["deleted", "red"], ["cancelled", "red"],
  ["tg_bound", "green"], ["unbound", "orange"], ["conflict", "red"], ["invite", "purple"],
  ["fired", "red"], ["archived", "muted"], ["moved", "orange"], ["restored", "green"],
  ["assigned", "cyan"], ["notified", "purple"], ["game_report", "green"], ["accept", "gold"],
  ["oo_edit", "orange"], ["hall_admin", "pink"], ["tea_cleanup", "cyan"],
  ["oo_tab", "cyan"], ["eo_tab", "purple"], ["op_tab", "orange"],
];

export function actionAccent(action: string): AuditAccent {
  for (const [k, a] of ACCENTS) if (action.includes(k)) return a;
  return "default";
}
